var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_12383)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0487 13.9956L100.628 9.96971C100.898 9.54765 100.776 8.99135 100.354 8.72718C99.9321 8.46301 99.371 8.591 99.1006 9.01306L96.5212 13.039C96.2508 13.461 96.3735 14.0173 96.7953 14.2815C97.2171 14.5457 97.7783 14.4177 98.0487 13.9956Z",
    fill: "url(#paint0_linear_1944_12383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1224 11.6459L92.8413 6.91889C92.9167 6.42334 92.5783 5.96505 92.0855 5.89528C91.5927 5.82551 91.1322 6.17068 91.0568 6.66624L90.3379 11.3932C90.2625 11.8888 90.6009 12.3471 91.0937 12.4168C91.5865 12.4866 92.0471 12.1414 92.1224 11.6459Z",
    fill: "url(#paint1_linear_1944_12383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.582 18.4309L105.828 16.2341C106.274 16.0038 106.446 15.4606 106.212 15.021C105.979 14.5813 105.429 14.4115 104.984 14.6419L100.737 16.8387C100.292 17.069 100.12 17.6122 100.353 18.0518C100.587 18.4915 101.136 18.6612 101.582 18.4309Z",
    fill: "url(#paint2_linear_1944_12383)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1944_12383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0938 82.188H34.2466C33.176 82.188 32.2107 82.833 31.8011 83.8221C31.3915 84.8112 31.6179 85.9498 32.375 86.7069L52.2221 106.554C52.9792 107.311 54.1178 107.537 55.1069 107.128C56.096 106.718 56.741 105.753 56.741 104.682V84.835C56.7408 83.3732 55.5557 82.188 54.0938 82.188Z",
    fill: "#BFC5CD",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9526 107.329H54.0938C52.6319 107.329 51.4467 106.144 51.4467 104.682V90.129C51.4467 88.6671 50.2616 87.482 48.7997 87.482H34.2467C32.7848 87.482 31.5996 86.2968 31.5996 84.8349V19.6231C31.5996 18.1613 32.7848 16.9761 34.2467 16.9761H90.9526C92.4144 16.9761 93.5996 18.1613 93.5996 19.6231V104.682C93.5996 106.144 92.4144 107.329 90.9526 107.329Z",
    fill: "#EBF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8602 25.3667C57.4525 25.3667 57.1221 25.6972 57.1221 26.1048V39.3905C57.1221 39.7981 57.4525 40.1286 57.8602 40.1286C58.2678 40.1286 58.5983 39.7981 58.5983 39.3905V26.8429H63.0268V32.7477V39.3905C63.0268 39.7981 63.3573 40.1286 63.7649 40.1286C64.1726 40.1286 64.503 39.7981 64.503 39.3905V33.4857H68.9316V39.3905C68.9316 39.7981 69.2621 40.1286 69.6697 40.1286C70.0773 40.1286 70.4078 39.7981 70.4078 39.3905V32.7477C70.4078 32.34 70.0773 32.0096 69.6697 32.0096H64.503V26.1048C64.503 25.6972 64.1726 25.3667 63.7649 25.3667H57.8602ZM60.4435 28.3191C60.0359 28.3191 59.7054 28.6495 59.7054 29.0572V29.7953C59.7054 30.2029 60.0359 30.5334 60.4435 30.5334H61.1816C61.5892 30.5334 61.9197 30.2029 61.9197 29.7953V29.0572C61.9197 28.6495 61.5892 28.3191 61.1816 28.3191H60.4435ZM59.7054 32.7477C59.7054 32.34 60.0359 32.0096 60.4435 32.0096H61.1816C61.5892 32.0096 61.9197 32.34 61.9197 32.7477V33.4857C61.9197 33.8934 61.5892 34.2238 61.1816 34.2238H60.4435C60.0359 34.2238 59.7054 33.8934 59.7054 33.4857V32.7477ZM60.4435 35.7C60.0359 35.7 59.7054 36.0305 59.7054 36.4381V37.1762C59.7054 37.5839 60.0359 37.9143 60.4435 37.9143H61.1816C61.5892 37.9143 61.9197 37.5839 61.9197 37.1762V36.4381C61.9197 36.0305 61.5892 35.7 61.1816 35.7H60.4435ZM66.3483 34.9619C65.9406 34.9619 65.6102 35.2924 65.6102 35.7V36.4381C65.6102 36.8458 65.9406 37.1762 66.3483 37.1762H67.0864C67.494 37.1762 67.8245 36.8458 67.8245 36.4381V35.7C67.8245 35.2924 67.494 34.9619 67.0864 34.9619H66.3483Z",
    fill: "#858A90",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.1254,
    height: 1.91384,
    rx: 0.956918,
    transform: "matrix(1 -2.33917e-08 -4.83312e-06 1 41.7559 47.5386)",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.537,
    height: 1.91384,
    rx: 0.956918,
    transform: "matrix(1 -3.38451e-08 -4.81799e-06 1 41.6064 52.3115)",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.1254,
    height: 1.91384,
    rx: 0.956918,
    transform: "matrix(1 -2.33917e-08 -4.83309e-06 1 41.7559 59.1479)",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6064 64.8778C41.6064 64.3493 42.0349 63.9209 42.5634 63.9209L83.1217 63.9209C83.6502 63.9209 84.0786 64.3493 84.0786 64.8778C84.0786 65.4063 83.6502 65.8347 83.1217 65.8347L42.5634 65.8347C42.0349 65.8347 41.6064 65.4063 41.6064 64.8778Z",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6064 69.6508C41.6064 69.1223 42.0349 68.6938 42.5634 68.6938L83.1217 68.6938C83.6502 68.6938 84.0786 69.1223 84.0786 69.6508C84.0786 70.1793 83.6502 70.6077 83.1217 70.6077L42.5634 70.6077C42.0349 70.6077 41.6064 70.1793 41.6064 69.6508Z",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.1254,
    height: 1.91384,
    rx: 0.95692,
    transform: "matrix(1 -2.33918e-08 -4.83309e-06 1 41.7559 72.729)",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6064 78.4589C41.6064 77.9304 42.0349 77.502 42.5634 77.502L83.1217 77.502C83.6502 77.502 84.0786 77.9304 84.0786 78.4589C84.0786 78.9874 83.6502 79.4158 83.1217 79.4158L42.5634 79.4158C42.0349 79.4158 41.6064 78.9874 41.6064 78.4589Z",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6064 83.2318C41.6064 82.7033 42.0349 82.2749 42.5634 82.2749L83.1217 82.2749C83.6502 82.2749 84.0786 82.7033 84.0786 83.2318C84.0786 83.7603 83.6502 84.1887 83.1217 84.1887L42.5634 84.1887C42.0349 84.1887 41.6064 83.7603 41.6064 83.2318Z",
    fill: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9141 99.7211C77.3922 97.804 78.4141 93.6537 78.1726 90.7535C77.9677 88.2939 76.1558 88.0903 73.9875 88.8345C70.6187 89.9908 66.9302 91.9713 66.235 95.6293C65.7216 98.3309 65.3504 102.841 68.9067 103.708C71.9491 104.451 74.2584 100.364 74.0492 97.8245C73.9417 96.5183 72.1652 97.0799 71.9644 98.0859C71.4121 100.853 74.6136 102.203 77.0298 101.842C78.2521 101.659 79.1868 100.918 79.9022 99.9824C80.0479 99.7918 80.3432 98.9184 80.7052 99.1685C81.7086 99.8616 82.7687 100.327 83.8093 100.931",
    stroke: "#C4CDD5",
    strokeWidth: 1.15485,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1944_12383)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 100.184,
    cy: 70.3807,
    rx: 15.1556,
    ry: 15.5,
    transform: "rotate(-176.081 100.184 70.3807)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.672 61.2291L101.489 74.1175L98.4108 73.9067L98.8619 60.9681L102.672 61.2291ZM97.6207 77.5504C97.6593 76.9869 97.8709 76.5279 98.2555 76.1734C98.6507 75.8093 99.172 75.6495 99.8194 75.6938C100.457 75.7375 100.947 75.9666 101.288 76.3812C101.631 76.7855 101.783 77.2694 101.744 77.8329C101.707 78.3759 101.491 78.8294 101.096 79.1935C100.701 79.5473 100.185 79.7024 99.5478 79.6587C98.9004 79.6143 98.4054 79.39 98.0628 78.9857C97.7309 78.5718 97.5835 78.0934 97.6207 77.5504Z",
    fill: "#B4BDC6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1944_12383",
    x: 13.1221,
    y: 5.42761,
    width: 89.7163,
    height: 118.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.61939,
    dy: 2.30969
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.92908
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1944_12383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1944_12383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1944_12383",
    x: 85.0259,
    y: 54.8818,
    width: 39.3154,
    height: 44.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1944_12383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1944_12383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1944_12383",
    x1: 100.203,
    y1: 8.25781,
    x2: 94.9488,
    y2: 11.2914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1944_12383",
    x1: 91.7568,
    y1: 5.52783,
    x2: 88.1906,
    y2: 10.4363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1944_12383",
    x1: 106.316,
    y1: 14.5391,
    x2: 100.249,
    y2: 14.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_12383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white",
    transform: "translate(0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEntity);
export default __webpack_public_path__ + "static/media/Empty-entity.5588512c966a281c998ecffa1030bcad.svg";
export { ForwardRef as ReactComponent };